module.exports = __webpack_public_path__ + "assets/img/b748279eac7e08f9b9dfd426d9237aae.svg";